import React from "react";
import { SectionHeading } from "../SectionHeading";
export function StorySection() {
  return <section className="bg-cream px-4 py-14 sm:py-20" data-id="element-278" data-mp="6v7ti0gu6dgh">
      <SectionHeading eyebrow="From clinical uncertainty to a clearer path forward" title={<>
            You don't need another collection of medical guidelines.{" "}
            <em className="text-rose" data-id="element-280" data-mp="gruauf9yemdr">You need a practical way to organize the information you already have.</em>
          </>} data-id="element-279" data-mp="6xtybscceev0" />
      <div className="mx-auto mt-8 max-w-2xl space-y-5 text-[17px] leading-relaxed text-ink/85" data-id="element-281" data-mp="pu3h2sy6vtlc">
        <p data-id="element-282" data-mp="ukscukgwjcqa">
          As physicians, we know that menopause care involves multiple considerations. Symptoms, medical history, risk
          factors, patient preferences, and treatment options all influence the clinical assessment.
        </p>
        <p className="border-l-4 border-rose pl-4 font-serif text-xl font-semibold leading-snug text-plum" data-id="element-283" data-mp="14lcgftrw8tbo">
          The challenge is knowing how to organize these elements during a real consultation.
        </p>
        <p data-id="element-284" data-mp="1vo2lksn0t66n">
          That's why I created <strong data-id="element-285" data-mp="1qqj83uy5cxfr">Menopause Decision Map™</strong>. I wanted to bring the process into a visual,
          structured format that makes it easier to navigate the questions that matter, identify what needs further
          evaluation, and document the next steps.
        </p>
        <p data-id="element-286" data-mp="1gv96377r0q1z">
          Instead of starting from scratch every time, you can consult a structured map and follow the relevant
          assessment pathway.
        </p>
      </div>
    </section>;
}